import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { getCreateABundleUrl } from 'pricing-pages-lib/utils/urls';
import { useHistory } from 'react-router-dom';
import { useTierQueryParam } from '../../hooks/useTierQueryParam';
import { PRODUCT_PAGE_HEADER } from '../constants/tracking/TrackingSources';
import { useIsInAppAuth } from '../hooks/user/useUserInfo';
import { trackClickedLink } from '../utils/tracking/trackingEventUtils';
import { isValidTier } from '../utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
const CalculatorAnchorLink = ({
  defaultProductApiName
}) => {
  const history = useHistory();
  const isAuthApp = useIsInAppAuth();
  const tierQueryParam = useTierQueryParam();
  const handleClick = () => {
    const queryParams = {
      products: [`${defaultProductApiName}_1`],
      packs: []
    };
    let url = getCreateABundleUrl(isAuthApp, queryParams);
    if (tierQueryParam && isValidTier(tierQueryParam)) {
      const separator = url.includes('?') ? '&' : '?';
      url = `${url}${separator}tier=${tierQueryParam}`;
    }
    trackClickedLink({
      type: 'internal',
      url,
      trackingSource: PRODUCT_PAGE_HEADER,
      value: getI18nText('pricingPage.pages.calculateYourPrice', {
        locale: 'en-us'
      }),
      name: 'calculate-your-price'
    });
    history.push(url);
  };
  if (isAuthApp) {
    return null;
  }
  return /*#__PURE__*/_jsx(Link, {
    marginInlineStart: "200",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.calculateYourPrice"
    })
  });
};
export default CalculatorAnchorLink;